import { render, staticRenderFns } from "./WHColors.vue?vue&type=template&id=27983f68&"
import script from "./WHColors.vue?vue&type=script&lang=js&"
export * from "./WHColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports